module.exports = __webpack_public_path__ + "img/2022051912244330017e.85b92be5.jpg";